import React from 'react';
import { ArrowRight } from 'lucide-react';
import Seo from '../seo/Seo';
import { breadcrumbLd, personLd, LINKEDIN_PRINCIPAL } from '../seo/jsonLd';
import Breadcrumb from './Breadcrumb';
import CTASection from './CTASection';

const CRUMBS = [{ name: 'Home', path: '/' }, { name: 'About' }];

const practices = [
  {
    term: 'AI agents and agentic workflows',
    detail:
      'We design and build agents that use your tools, read your documents, and carry multi-step work to a finished result: an agent that acts, not a chatbot that answers. We also install AFK Development inside engineering teams. The work specializes in Anthropic Claude and is model- and cloud-portable, so Claude is the specialization, not a constraint you inherit.',
  },
  {
    term: 'AWS cloud infrastructure',
    detail:
      'A second practice has run production AWS for over ten years, with its own clients, its own case studies, and its own free infrastructure assessment. That decade is why the agent work ships with evaluation, logging and alerting from day one. It is a claim about how we build, not about where the agents run.',
  },
];

const AboutPage: React.FC = () => (
  <div className="bg-gray-900 text-white">
    <Seo
      title="Rafał Janicki | Kult.io"
      description="Who you are talking to at Kult.io: the principal behind the AI agent practice and ten years of production AWS."
      path="/about"
      jsonLd={[breadcrumbLd(CRUMBS), personLd]}
    />

    <div className="border-b border-gray-800 bg-gray-950">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 md:py-20">
        <h1 className="font-display text-display-md font-bold text-balance text-white sm:text-display-lg">
          Who you are talking to
        </h1>
        <p className="mt-6 max-w-measure text-lg text-gray-300">
          Rafał Janicki runs Kult.io from Kraków, working with clients internationally. He is a
          Claude Certified Architect, certified by Anthropic.
        </p>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 md:py-20">
      <Breadcrumb crumbs={CRUMBS} />

      <section className="mt-10 border-t border-gray-800">
        <h2 className="sr-only">Two practices</h2>
        <dl>
          {practices.map((practice) => (
            <div
              key={practice.term}
              className="grid gap-x-10 gap-y-3 border-b border-gray-800 py-8 lg:grid-cols-[1fr_2fr]"
            >
              <dt className="font-display text-display-sm font-medium text-white">{practice.term}</dt>
              <dd className="max-w-measure text-gray-300">{practice.detail}</dd>
            </div>
          ))}
        </dl>
      </section>

      <p className="mt-8">
        <a
          href={LINKEDIN_PRINCIPAL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-[44px] items-center py-2.5 font-medium text-accent-400 transition-colors duration-150 hover:text-accent-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400"
        >
          Rafał on LinkedIn <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" />
        </a>
      </p>
    </div>

    <CTASection placement="about" />
  </div>
);

export default AboutPage;
